import React, { useEffect, useState } from 'react';

const fmtNum = (n) => (n ?? 0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});

function minsToDisplay(totalMins, avgMins) {
  totalMins = Math.round(totalMins); avgMins = Math.floor(avgMins || 864);
  const halfMins = Math.floor(avgMins / 2); const quarterMins = Math.floor(avgMins / 4);
  const days = Math.floor(totalMins / avgMins); let rem = totalMins % avgMins;
  let half = 0, quarter = 0;
  if (rem >= halfMins) { half = 1; rem -= halfMins; } else if (rem >= quarterMins) { quarter = 1; rem -= quarterMins; }
  const hours = Math.floor(rem / 60); const minutes = rem % 60;
  let s = '';
  if (days > 0) s += days + ' يوم';
  if (half > 0) s += (s ? ' و' : '') + 'نصف يوم';
  if (quarter > 0) s += (s ? ' و' : '') + 'ربع يوم';
  if (hours > 0) s += (s ? ' و' : '') + hours + ' ساعة';
  if (minutes > 0) s += (s ? ' و' : '') + minutes + ' دقيقة';
  return s || '—';
}

function ReportView({ token }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [report, setReport] = useState(null);

  useEffect(() => {
    fetch(`/api/report-link/${token}/`)
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) setError(data.error || 'حدث خطأ في تحميل التقرير');
        else setReport(data);
        setLoading(false);
      })
      .catch(() => { setError('تعذر الاتصال بالخادم'); setLoading(false); });
  }, [token]);

  if (loading) return <div style={{direction:'rtl',textAlign:'center',padding:'3rem',fontFamily:'sans-serif'}}><p>جاري تحميل التقرير...</p></div>;
  if (error) return <div style={{direction:'rtl',textAlign:'center',padding:'3rem',fontFamily:'sans-serif'}}><h2>⚠️ {error}</h2><p>يرجى التواصل مع مدير الشراكة للحصول على رابط جديد.</p></div>;

  const d = report.data;

  // عرض أنواع التقارير المختلفة
  const fmtNum2 = (n) => (n ?? 0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits: 2, maximumFractionDigits: 2});
  const box2 = {border:'1px solid #e5e5e5',borderRadius:8,padding:'1rem',marginBottom:'1rem'};
  const ttl2 = {fontWeight:'bold',fontSize:'1.05rem',marginBottom:'0.5rem'};

  if (['account','schedule','expenses','bills','both'].includes(report.report_type)) {
    const me = d.partners?.find(p => p.name === report.partner_name);
    const meId = me?.id;
    const s = (d.summary||[]).find(x => x.id === meId) || {};
    const isDays = d.partnership?.quota_type === 'days';
    const avgDayMinutes = d.avg_day_minutes || 864;
    const fmtHrs = (totalMins) => { const h=Math.floor(totalMins/60); const m=Math.round(totalMins%60); return m>0?`${h} ساعة و${m} دقيقة`:`${h} ساعة`; };
    const fmtExactDH = (daysDec, hoursDec) => {
      daysDec = Math.round((daysDec||0) * 100) / 100;
      hoursDec = Math.round((hoursDec||0) * 100) / 100;
      let dayPart = '';
      if (daysDec > 0) {
        const whole = Math.floor(daysDec + 1e-9);
        const rem = Math.round((daysDec - whole) * 4) / 4;
        if (whole > 0) dayPart += whole + ' يوم';
        if (rem === 0.5) dayPart += (dayPart ? ' و' : '') + 'نصف يوم';
        else if (rem === 0.25) dayPart += (dayPart ? ' و' : '') + 'ربع يوم';
        else if (rem === 0.75) dayPart += (dayPart ? ' و' : '') + 'ثلاثة أرباع اليوم';
      }
      let hourPart = '';
      if (hoursDec > 0) {
        const hoursStr = Number.isInteger(hoursDec) ? String(hoursDec) : hoursDec.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits:2});
        hourPart = hoursStr + ' ساعة';
      }
      if (!dayPart && !hourPart) return '—';
      return dayPart && hourPart ? `${dayPart} و${hourPart}` : (dayPart || hourPart);
    };
    const sumExactDH2 = (fromD, toD, pid) => {
      let days = 0, hours = 0;
      (d.sessions||[]).forEach(sess => {
        if (sess.no_operation) return;
        if (fromD && sess.date < fromD) return;
        if (toD && sess.date > toD) return;
        const spid = sess.sub_partner_id != null ? sess.sub_partner_id : sess.partner_id;
        if (String(spid) !== String(pid)) return;
        if (sess.run_type === 'full') days += 1;
        else if (sess.run_type === 'half') days += 0.5;
        else if (sess.run_type === 'quarter') days += 0.25;
        else if (sess.run_type === 'hours') hours += parseFloat(sess.hours || 0);
        hours += parseFloat(sess.extra_hours || 0);
      });
      return { days, hours };
    };
    const dispHrs = (m) => isDays ? (() => { const ex = sumExactDH2(report.from_date, report.to_date, meId); return fmtExactDH(ex.days, ex.hours); })() : fmtHrs(m);
    const bal = Number(s.balance||0);
    const balTxt = Math.abs(bal)<0.01 ? '✅ مسدد رصيد 0' : bal>0 ? `✅ له رصيد +${fmtNum2(bal)}` : `❌ مديون ${fmtNum2(Math.abs(bal))}`;
    const totalHrsMin = (d.sessions||[]).filter(sess=>!sess.no_operation&&((sess.partner_id===meId&&!sess.sub_partner_id)||sess.sub_partner_id===meId)).reduce((sum,sess)=>sum+Number(sess.total_hours||sess.hours||0)*60,0);
    const totalAllMin = (d.sessions||[]).reduce((sum,sess)=>sum+Number(sess.total_hours||sess.hours||0)*60,0);
    const pct = totalAllMin>0?(totalHrsMin/totalAllMin*100).toFixed(1):'0';
    return (
      <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
        <h2>💧 {report.partnership_name}</h2>
        <p><b>الشريك:</b> {report.partner_name}</p>
        <p><b>الفترة:</b> {report.from_date} إلى {report.to_date}</p>
        {['account','both'].includes(report.report_type) && <div style={box2}><div style={ttl2}>💰 الحساب</div><p>حالة الرصيد: <b>{balTxt}</b></p></div>}
        {['schedule','both'].includes(report.report_type) && <div style={box2}>
          <div style={ttl2}>⏱️ {isDays?'أيام':'ساعات'} التشغيل</div>
          {isDays && <p>إجمالي تشغيلكم: <b>{dispHrs(totalHrsMin)}</b> ({pct}٪ من الإجمالي)</p>}
          <p>إجمالي ساعاتكم: <b>{(()=>{const h=Math.floor(totalHrsMin/60);const m=Math.round(totalHrsMin%60);return m>0?`${h} ساعة و${m} دقيقة`:`${h} ساعة`;})()}</b></p>
          {(()=>{
            const cycleSessions=(d.sessions||[]).filter(s=>!s.no_operation&&((s.partner_id===meId&&!s.sub_partner_id)||(s.sub_partner_id===meId)));
            if(!cycleSessions.length) return null;
            const cycleStart=d.partnership?.start_date||report.from_date||'';
            const cycleEnd=new Date().toISOString().split('T')[0];
            return <div><p><b>📅 أيام التشغيل خلال الدورة الحالية من {cycleStart} إلى {cycleEnd}:</b></p>
              {cycleSessions.map((s,i)=>{
                const hM=Math.round(s.total_hours*60); const hH=Math.floor(hM/60); const hMin=hM%60;
                const hDisp=hMin>0?`${hH} ساعة و${hMin} دقيقة`:`${hH} ساعة`;
                const type=(s.partner_id===meId&&!s.sub_partner_id)?'أساسي':'بديل';
                return <p key={i}>📆 {s.date} ({s.day}) - {type} - {hDisp}</p>;
              })}
            </div>;
          })()}
        </div>}
        {['expenses','both'].includes(report.report_type) && <div style={box2}><div style={ttl2}>📋 المصروفات</div><p>نصيبكم من المصروفات: <b>{fmtNum2(s.expense_share)}</b> ريال</p></div>}
        {['bills','both'].includes(report.report_type) && <div style={box2}><div style={ttl2}>🔌 تفصيل الفواتير</div>{(d.bill_details||[]).map(b=>{const myMins=b.partner_minutes?.[String(meId)]??Number(b.partner_hours?.[meId]||0)*60;const myShare=Number(b.shares?.[meId]||0);const bDisp=isDays?(()=>{const ex=sumExactDH2(b.from_date,b.to_date,meId);return fmtExactDH(ex.days,ex.hours);})():fmtHours(myMins);return <p key={b.id}>فاتورة {b.number} ({b.from_date} ← {b.to_date}) · {isDays?'أيامكم':'ساعاتكم'}: {bDisp} · مستحقكم: <b>{fmtNum2(myShare)}</b> ريال</p>;})}</div>}
        <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
      </div>
    );
  }

  if (report.report_type === 'bill_current_all') {
    const lastBill = (d.bill_details||[])[(d.bill_details||[]).length-1];
    return (
      <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
        <h2>💧 {report.partnership_name}</h2>
        {lastBill && <p><b>فاتورة رقم ({lastBill.number}):</b> {lastBill.from_date} إلى {lastBill.to_date}</p>}
        {lastBill && <p>المبلغ الكلي: <b>{fmtNum2(lastBill.amount)}</b> ريال</p>}
        <div style={box2}><div style={ttl2}>توزيع الفاتورة على الشركاء</div>
        {(d.summary||[]).map(p=>{const bal=Number(p.balance||0);const balTxt=Math.abs(bal)<0.01?'✅ مسدد':bal>0?`✅ له رصيد +${fmtNum2(bal)}`:`❌ مديون ${fmtNum2(Math.abs(bal))}`;const share=lastBill?Number(lastBill.shares?.[p.id]||0):0;return <p key={p.id}>👤 <b>{p.name}</b>: {fmtNum2(share)} ريال · {balTxt}</p>;})}
        </div>
        <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
      </div>
    );
  }

  if (report.report_type === 'group_summary') {
    return (
      <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
        <h2>💧 {report.partnership_name}</h2>
        <div style={box2}><div style={ttl2}>💰 ملخص حسابات الشركاء</div>
        {(d.summary||[]).map(p=>{const bal=Number(p.balance||0);const icon=Math.abs(bal)<0.01?'✅':bal>0?'✅':'❌';return(<div key={p.id} style={{marginBottom:'0.5rem'}}><p style={{margin:0}}>{icon} <b>{p.name}</b></p><p style={{margin:0,paddingRight:'1rem'}}>المستحق: {fmtNum2(p.total_required)} | دفع: {fmtNum2(p.total_paid)}</p><p style={{margin:0,paddingRight:'1rem'}}>رصيد: {bal>=0?'+':''}{fmtNum2(bal)} ريال</p></div>);})}
        </div>
        <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
      </div>
    );
  }

  if (['schedule_all','schedule_one','bill_schedule'].includes(report.report_type)) {
    const me = d.partners?.find(p => p.name === report.partner_name);
    const meId = me?.id;
    const isDays = d.partnership?.quota_type === 'days';
    const avgDayMinutes = d.avg_day_minutes || 864;
    const lastBill2 = (d.bill_details||[])[(d.bill_details||[]).length-1];
    const filteredSessions = report.report_type === 'schedule_all'
      ? (d.sessions||[]).filter(s=>!s.no_operation)
      : report.report_type === 'schedule_one'
        ? (d.schedule_rows||[]).filter(r=>r.partner_id===meId)
        : (d.sessions||[]).filter(s=>!s.no_operation&&(s.partner_id===meId&&!s.sub_partner_id||s.sub_partner_id===meId));
    return (
      <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
        <h2>💧 {report.partnership_name}</h2>
        {meId && report.report_type !== 'schedule_all' && <p><b>الشريك:</b> {report.partner_name}</p>}
        {lastBill2 && report.report_type==='bill_schedule' && <p><b>فاتورة {lastBill2.number}:</b> {lastBill2.from_date} إلى {lastBill2.to_date}</p>}
        {!lastBill2||report.report_type!=='bill_schedule' ? <p><b>الفترة:</b> {report.from_date} إلى {report.to_date}</p> : null}
        <div style={box2}><div style={ttl2}>📅 جدول التشغيل</div>
        {filteredSessions.length===0 && <p>لا يوجد تشغيل خلال هذه الفترة</p>}
        {filteredSessions.map((s,i)=>{
          const hrs=Number(s.total_hours||0);
          let dispStr;
          if (isDays && s.run_type) {
            if (s.run_type === 'full') dispStr = 'يوم كامل';
            else if (s.run_type === 'half') dispStr = 'نصف يوم';
            else if (s.run_type === 'quarter') dispStr = 'ربع يوم';
            else if (s.run_type === 'hours') dispStr = `${s.hours||0} ساعة`;
            else dispStr = hrs>0 ? `${hrs} ساعة` : '—';
            if (Number(s.extra_hours||0) > 0) dispStr += ` و${s.extra_hours} ساعة إضافية`;
          } else {
            const hrsInt=Math.floor(hrs);const minRem=Math.round((hrs-hrsInt)*60);
            dispStr = minRem>0?`${hrsInt} ساعة و${minRem} دقيقة`:`${hrsInt} ساعة`;
          }
          const opTypeLabel = s.op_type === 'طارئ' ? 'طارئ' : s.sub_partner_name ? 'بديل' : 'أساسي';
          return <p key={i}>📆 {s.date} ({s.day}){report.report_type==='schedule_all'?' ← '+s.real_operator_name+' ('+opTypeLabel+')':''} - {dispStr}</p>;
        })}
        </div>
        <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
      </div>
    );
  }

  // عرض الفاتورة الحالية - شريك
  if (report.report_type === 'bill_current_one') {
    const me = d.partners?.find(p => p.name === report.partner_name);
    const meId = me?.id;
    const s = (d.summary||[]).find(x => x.id === meId) || {};
    const lastBill = (d.bill_details||[])[(d.bill_details||[]).length-1];
    const isDays = d.partnership?.quota_type === 'days';
    const avgDayMinutes = d.avg_day_minutes || 864;
    const myHoursMin = lastBill ? Number(lastBill.partner_hours?.[meId]||0)*60 : 0;
    const myShare = lastBill ? Number(lastBill.shares?.[meId]||0) : 0;
    const bal = Number(s.balance||0);
    const balTxt = Math.abs(bal)<0.01 ? '✅ مسدد رصيد 0' : bal>0 ? `✅ له رصيد +${fmtNum(bal)}` : `❌ مديون ${fmtNum(Math.abs(bal))}`;
    const fmtHours = (totalMins) => { const h=Math.floor(totalMins/60); const m=Math.round(totalMins%60); return m>0?`${h} ساعة و${m} دقيقة`:`${h} ساعة`; };
    const fmtExactDH = (daysDec, hoursDec) => {
      daysDec = Math.round((daysDec||0) * 100) / 100;
      hoursDec = Math.round((hoursDec||0) * 100) / 100;
      let dayPart = '';
      if (daysDec > 0) {
        const whole = Math.floor(daysDec + 1e-9);
        const rem = Math.round((daysDec - whole) * 4) / 4;
        if (whole > 0) dayPart += whole + ' يوم';
        if (rem === 0.5) dayPart += (dayPart ? ' و' : '') + 'نصف يوم';
        else if (rem === 0.25) dayPart += (dayPart ? ' و' : '') + 'ربع يوم';
        else if (rem === 0.75) dayPart += (dayPart ? ' و' : '') + 'ثلاثة أرباع اليوم';
      }
      let hourPart = '';
      if (hoursDec > 0) {
        const hoursStr = Number.isInteger(hoursDec) ? String(hoursDec) : hoursDec.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits:2});
        hourPart = hoursStr + ' ساعة';
      }
      if (!dayPart && !hourPart) return '—';
      return dayPart && hourPart ? `${dayPart} و${hourPart}` : (dayPart || hourPart);
    };
    let displayHrs = fmtHours(myHoursMin);
    if (isDays && lastBill) {
      let exDays = 0, exHours = 0;
      (d.sessions||[]).forEach(sess => {
        if (sess.no_operation) return;
        if (sess.date < lastBill.from_date || sess.date > lastBill.to_date) return;
        const pid = sess.sub_partner_id != null ? sess.sub_partner_id : sess.partner_id;
        if (String(pid) !== String(meId)) return;
        if (sess.run_type === 'full') exDays += 1;
        else if (sess.run_type === 'half') exDays += 0.5;
        else if (sess.run_type === 'quarter') exDays += 0.25;
        else if (sess.run_type === 'hours') exHours += parseFloat(sess.hours || 0);
        exHours += parseFloat(sess.extra_hours || 0);
      });
      displayHrs = fmtExactDH(exDays, exHours);
    }
    const box = {border:'1px solid #e5e5e5',borderRadius:8,padding:'1rem',marginBottom:'1rem'};
    const ttl = {fontWeight:'bold',fontSize:'1.05rem',marginBottom:'0.5rem'};
    return (
      <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
        <h2>💧 {report.partnership_name}</h2>
        <p><b>الشريك:</b> {report.partner_name}</p>
        {lastBill && <p><b>فاتورة رقم ({lastBill.number}):</b> {lastBill.from_date} إلى {lastBill.to_date}</p>}
        <div style={box}>
          <div style={ttl}>🧾 تفاصيل الفاتورة</div>
          {lastBill && <p>المبلغ الكلي للفاتورة: <b>{fmtNum(lastBill.amount)}</b> ريال</p>}
          <p>{isDays?'أيام':'ساعات'} تشغيلكم مدة الفاتورة: <b>{displayHrs}</b></p>
          <p>تكاليف الفاتورة الخاصة بكم: <b>{fmtNum(myShare)}</b> ريال</p>
        </div>
        <div style={box}>
          <div style={ttl}>💰 الحساب</div>
          <p>حالة الرصيد: <b>{balTxt}</b></p>
        </div>
        <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
      </div>
    );
  }
  const me = d.partners.find(p => p.name === report.partner_name);
  const meId = me?.id;
  const s = (d.summary || []).find(x => x.id === meId) || {};
  const totalExpensesWithBills = (d.expenses||[]).reduce((sum,e)=>sum+Number(e.total||0),0) + (d.bill_details||[]).reduce((sum,b)=>sum+Number(b.amount||0),0);
  const totalRevenueAll = (d.summary||[]).reduce((sum,p)=>sum+Number(p.total_paid||0),0);
  const isDays = d.partnership?.quota_type === 'days';
  const avgDayMinutes = d.avg_day_minutes || 864;

  const fmtHours = (totalMins) => {
    const h = Math.floor(totalMins / 60);
    const m = Math.round(totalMins % 60);
    return m > 0 ? `${h} ساعة و${m} دقيقة` : `${h} ساعة`;
  };


  const fmtExactDH = (daysDec, hoursDec) => {
    daysDec = Math.round((daysDec||0) * 100) / 100;
    hoursDec = Math.round((hoursDec||0) * 100) / 100;
    let dayPart = '';
    if (daysDec > 0) {
      const whole = Math.floor(daysDec + 1e-9);
      const rem = Math.round((daysDec - whole) * 4) / 4;
      if (whole > 0) dayPart += whole + ' يوم';
      if (rem === 0.5) dayPart += (dayPart ? ' و' : '') + 'نصف يوم';
      else if (rem === 0.25) dayPart += (dayPart ? ' و' : '') + 'ربع يوم';
      else if (rem === 0.75) dayPart += (dayPart ? ' و' : '') + 'ثلاثة أرباع اليوم';
    }
    let hourPart = '';
    if (hoursDec > 0) {
      const hoursStr = Number.isInteger(hoursDec) ? String(hoursDec) : hoursDec.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits:2});
      hourPart = hoursStr + ' ساعة';
    }
    if (!dayPart && !hourPart) return '—';
    return dayPart && hourPart ? `${dayPart} و${hourPart}` : (dayPart || hourPart);
  };
  const sumExactDH = (sessionsArr, fromDate, toDate, partnerId) => {
    let days = 0, hours = 0;
    (sessionsArr||[]).forEach(sess => {
      if (sess.no_operation) return;
      if (fromDate && sess.date < fromDate) return;
      if (toDate && sess.date > toDate) return;
      if (partnerId != null) {
        const pid = sess.sub_partner_id != null ? sess.sub_partner_id : sess.partner_id;
        if (String(pid) !== String(partnerId)) return;
      }
      if (sess.run_type === 'full') days += 1;
      else if (sess.run_type === 'half') days += 0.5;
      else if (sess.run_type === 'quarter') days += 0.25;
      else if (sess.run_type === 'hours') hours += parseFloat(sess.hours || 0);
      hours += parseFloat(sess.extra_hours || 0);
    });
    return { days, hours };
  };
  const displayMins = (totalMins) => isDays ? minsToDisplay(totalMins, avgDayMinutes) : fmtHours(totalMins);
  const displayExact = (fromD, toD, pid) => { const ex = sumExactDH(d.sessions, fromD, toD, pid); return fmtExactDH(ex.days, ex.hours); };
  const mySessions = (d.sessions||[]).filter(sess=>!sess.no_operation&&((sess.partner_id===meId&&!sess.sub_partner_id)||(sess.sub_partner_id===meId)||(sess.extra_list||[]).some(ex=>ex.partner_id===meId))&&!(sess.partner_id===meId&&sess.sub_partner_id&&sess.sub_partner_id!==meId));
  const myTotalMinutes = mySessions.reduce((sum,sess)=>sum+Number(sess.total_hours||sess.hours||0)*60,0);
  const totalCycleMinutes = (d.sessions||[]).reduce((sum,sess)=>sum+Number(sess.total_hours||sess.hours||0)*60,0);
  const myPercent = totalCycleMinutes>0?(myTotalMinutes/totalCycleMinutes*100).toFixed(1):'0';
  const lastBill = (d.bill_details||[])[(d.bill_details||[]).length-1];
  const lastBillToDate = lastBill?.to_date || '2000-01-01';
  const lastBillFromDate = lastBill?.from_date || lastBillToDate;
  const myScheduleDates = (d.sessions||[]).filter(s=>!s.no_operation&&s.date>=lastBillFromDate&&s.date<=lastBillToDate&&((s.partner_id===meId&&!s.sub_partner_id)||(s.sub_partner_id===meId)));
  const lastBillMyHours = lastBill?(lastBill.partner_minutes?.[meId]??lastBill.partner_minutes?.[String(meId)]??Number(lastBill.partner_hours?.[meId]||0)*60):0;
  const lastBillTotalMinutes = lastBill?Number(lastBill.total_hours||0)*60:0;
  const lastBillAvgMinutes = (lastBill?.avg_day_minutes) || avgDayMinutes;
  const lastBillPercent = lastBillTotalMinutes>0?(lastBillMyHours/lastBillTotalMinutes*100).toFixed(1):'0';
  const box = {border:'1px solid #e5e5e5',borderRadius:8,padding:'1rem',marginBottom:'1rem'};
  const ttl = {fontWeight:'bold',fontSize:'1.05rem',marginBottom:'0.5rem'};

  return (
    <div style={{direction:'rtl',fontFamily:'sans-serif',maxWidth:'700px',margin:'0 auto',padding:'1.5rem',lineHeight:1.9}}>
      <h2>💧 {report.partnership_name}</h2>
      <p><b>الشريك:</b> {report.partner_name}</p>
      <p><b>نوع التقرير:</b> {report.report_type_display}</p>
      <p><b>الفترة:</b> {report.from_date} إلى {report.to_date}</p>
      <div style={box}>
        <div style={ttl}>💰 المصروفات</div>
        <p>المبلغ الكلي للمصروفات (شاملة الفواتير): <b>{fmtNum(totalExpensesWithBills)}</b> ريال</p>
        <p>المصروفات الخاصة بكم: <b>{fmtNum(s.expense_share)}</b> ريال</p>
        <p>الفواتير الخاصة بكم: <b>{fmtNum(s.bill_share)}</b> ريال</p>
        <p>المصروفات شاملة الفواتير: <b>{fmtNum(s.total_required)}</b> ريال</p>
      </div>
      <div style={box}>
        <div style={ttl}>💵 الإيرادات</div>
        <p>المبلغ الكلي للإيرادات: <b>{fmtNum(totalRevenueAll)}</b> ريال</p>
        <p>الإيرادات الخاصة بكم: <b>{fmtNum(s.total_paid)}</b> ريال</p>
        <p>ما تم تحصيلها منكم: <b>{fmtNum(s.paid)}</b> ريال</p>
      </div>
      <div style={box}>
        <div style={ttl}>⏱️ أيام التشغيل</div>
        <p>{isDays ? "أيام/ساعات" : "ساعات"} التشغيل الخاصة بكم: <b>{isDays ? displayExact(report.from_date, report.to_date, meId) : displayMins(myTotalMinutes)}</b></p>
        <p>نسبة تشغيلكم: <b>{myPercent}٪</b></p>
        {lastBill&&<p>زمن تشغيلكم في الفاتورة الأخيرة: <b>{isDays ? displayExact(lastBill.from_date, lastBill.to_date, meId) : minsToDisplay(lastBillMyHours, Math.floor(lastBillAvgMinutes))}</b> من أصل <b>{isDays ? displayExact(lastBill.from_date, lastBill.to_date, null) : minsToDisplay(lastBillTotalMinutes, Math.floor(lastBillAvgMinutes))}</b> ({lastBillPercent}٪)</p>}
      </div>
      <div style={box}>
        <div style={ttl}>📅 جدول تشغيلك</div>
        {myScheduleDates.length===0&&<p>لا يوجد جدول تشغيل خلال هذه الفترة</p>}
        {myScheduleDates.map((r,i)=><p key={i}>📆 {r.date} ({r.day})</p>)}
      </div>
      <div style={box}>
        <div style={ttl}>🔌 الفواتير</div>
        {(d.bill_details||[]).map(b=>{
          const myHoursMin = b.partner_minutes?.[meId] ?? b.partner_minutes?.[String(meId)] ?? Number(b.partner_hours?.[meId]||0)*60;
          const myShare=Number(b.shares?.[meId]||0);
          const billDisp = isDays ? displayExact(b.from_date, b.to_date, meId) : fmtHours(myHoursMin);
          return <p key={b.id}>فاتورة {b.number} ({b.from_date} ← {b.to_date}) · {isDays?"أيامكم":"ساعاتكم"}: {billDisp} · مستحقكم: <b>{fmtNum(myShare)}</b> ريال</p>;
        })}
      </div>
      <div style={box}>
        <div style={ttl}>💰 الحساب</div>
        <p>حالة الرصيد: <b>{Math.abs(Number(s.balance||0))<0.01 ? '✅ مسدد رصيد 0' : Number(s.balance||0)>0 ? `✅ له رصيد +${fmtNum(s.balance)}` : `❌ مديون ${fmtNum(Math.abs(s.balance))}`}</b></p>
      </div>
      <p style={{color:'#888',fontSize:'0.85rem'}}>للإحاطة والاطلاع 🤝</p>
    </div>
  );
}

export default ReportView;
